
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Grupo 272","xmlns":"http://www.w3.org/2000/svg","width":"38","height":"37"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Polígono 1","d":"M19 0l3.78 3.73 5.115-1.58 1.58 5.026 5.277.933-.982 5.17L38 16.51l-3.319 4.13 2.219 4.79-4.9 2.144-.308 5.25-5.351-.333L23.58 37 19 34.266 14.42 37l-2.76-4.509-5.351.333L6 27.574 1.1 25.43l2.219-4.79L0 16.51l4.231-3.231-.982-5.17 5.277-.933 1.58-5.026 5.114 1.58z","fill":"#2e7fb9"}}),_c('text',{attrs:{"transform":"translate(17.5 26)","fill":"#fff","font-size":"21","font-family":"FontAwesome6Free-Solid, 'Font Awesome \\36 Free'"}},[_c('tspan',{attrs:{"x":"0","y":"0"}},[_v('exclamation')])])])
          )
        }
      }
    